(function(window, document, $, undefined){

  // $('input[type="range"]').ionRangeSlider({
  //     skin: "round",
  //     // hide_min_max: true,
  //     // hide_from_to: true,
  // });
  
})(window, document, jQuery);
